import {formatDateTime} from './dateUtils'

function isResolved(caseReportStatus) {
  if (caseReportStatus === "RE" || caseReportStatus === "RP") {
    return true
  } else {
    return false
  }
}

/**
 * Returns a resolution string using the last ReportStatusActivity:RESOLVED status
 */
function getResolvedByString(activities) {
  for (let i = activities.length - 1; i >= 0; i--) {
    const activity = activities[i];
    if (activity.type === "STATUS" && (activity.status === "RP" || activity.status === "RE")) {
      return `Report resolved by ${activity.userName} on ${formatDateTime(activity.date)}`;
    }
  }
  return null; // or throw error, depending on requirements
}

export { isResolved, getResolvedByString }